export const DEFAULT_APPEARANCE = {
  fontSize: 14,
  titleFontSize: 15,
  displayFontSize: 32,
}

export const APPEARANCE_FIELDS = [
  {
    key: 'fontSize',
    label: 'Body font size (px)',
    type: 'number',
    min: 10,
    max: 48,
    default: DEFAULT_APPEARANCE.fontSize,
  },
  {
    key: 'titleFontSize',
    label: 'Title font size (px)',
    type: 'number',
    min: 10,
    max: 40,
    default: DEFAULT_APPEARANCE.titleFontSize,
  },
  {
    key: 'displayFontSize',
    label: 'Display / big numbers (px)',
    type: 'number',
    min: 16,
    max: 96,
    default: DEFAULT_APPEARANCE.displayFontSize,
  },
]

export function clampPx(value, min, max, fallback) {
  const n = Number(value)
  if (!Number.isFinite(n)) return fallback
  return Math.min(max, Math.max(min, Math.round(n)))
}

export function normalizeAppearance(config = {}) {
  return {
    fontSize: clampPx(config.fontSize, 10, 48, DEFAULT_APPEARANCE.fontSize),
    titleFontSize: clampPx(config.titleFontSize, 10, 40, DEFAULT_APPEARANCE.titleFontSize),
    displayFontSize: clampPx(config.displayFontSize, 16, 96, DEFAULT_APPEARANCE.displayFontSize),
  }
}

/** Inline CSS vars for WidgetWrapper */
export function appearanceStyle(config = {}) {
  const a = normalizeAppearance(config)
  return {
    '--ws-font-size': `${a.fontSize}px`,
    '--ws-title-size': `${a.titleFontSize}px`,
    '--ws-display-size': `${a.displayFontSize}px`,
  }
}
